module.exports = __webpack_public_path__ + "img/local-13.a4d6e18e.jpg";